var exports = {
  "HM": "UserAreaSkeleton.module__userArea___UENFd0",
  "nd": "UserAreaSkeleton.module__panel___UENFd0",
  "zl": "UserAreaSkeleton.module__voicePanel___UENFd0",
  "Qs": "UserAreaSkeleton.module__content___UENFd0",
  "D_": "UserAreaSkeleton.module__identity___UENFd0",
  "Ky": "UserAreaSkeleton.module__identityText___UENFd0",
  "S7": "UserAreaSkeleton.module__nameRow___UENFd0",
  "jf": "UserAreaSkeleton.module__statusRow___UENFd0",
  "ne": "UserAreaSkeleton.module__controls___UENFd0",
};

module.exports = exports;
